export default "__VITE_ASSET__75287c80__"